import axios from 'axios';
import { DailyReportTower } from '../types/dailyReportTypes';
import apiClient from './apiClient';

export const getAllDailyReportTowers = async () => {
  try {
    const response = await apiClient.get(`/Daily-report-towers`);
    return response.data;
  } catch (error) {
    console.error('Error fetching all daily report towers:', error);
    throw error;
  }
};

export const getDailyReportTowerById = async (id: number) => {
  try {
    const response = await apiClient.get(`/Daily-report-towers/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching daily report tower with id ${id}:`, error);
    throw error;
  }
};

export const getDailyReportTowersByDailyReportId = async (idDailyReport: number) => {
  try {
    const response = await apiClient.get(`/Daily-report-towers/by-daily-report`, {
      params: { idDailyReport },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching daily report towers by daily report id:', error);
    throw error;
  }
};

export const getDailyReportTowersByTowerNumber = async (towerNumber: string) => {
  try {
    const response = await apiClient.get(`/Daily-report-towers/by-tower-number`, {
      params: { towerNumber },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching daily report towers by tower number:', error);
    throw error;
  }
};

export const getDailyReportTowersByActivityId = async (activityId: number) => {
  try {
    const response = await apiClient.get(`/Daily-report-towers/${activityId}/towers`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener las torres asociadas a la actividad:', error);
    throw error;
  }
};

export const createDailyReportTower = async (dailyReportTower: DailyReportTower) => {
  try {
    const response = await apiClient.post(`/Daily-report-towers`, dailyReportTower);
    return response.data;
  } catch (error) {
    console.error('Error creating daily report tower:', error);
    throw error;
  }
};

export const updateDailyReportTower = async (dailyReportTower: DailyReportTower) => {
  try {
    const response = await apiClient.put(`/Daily-report-towers/update`, dailyReportTower);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar la torre`, error);
    throw error;
  }
};

export const deleteDailyReportTower = async (id: number) => {
  try {
    await apiClient.delete(`/Daily-report-towers/${id}`);
  } catch (error) {
    console.error(`Error deleting daily report tower with id ${id}:`, error);
    throw error;
  }
};

export const validateTowerProgress = async (towerId: number, idActivity: number, progressPercentage: number) => {
  try {
    const response = await apiClient.post(`/Daily-report-towers/valid`, {
      towerId,
      idActivity,
      progressPercentage,
    });

    return response.data;
} catch (error) {
    console.error("Error en la validación de progreso de torre", error);
    throw error;
  }
};